module.exports = __webpack_public_path__ + "img/mic7.da1c2b55.jpg";